import { render, staticRenderFns } from "./UploadV2Icon.vue?vue&type=template&id=b13c91b2&"
import script from "./UploadV2Icon.vue?vue&type=script&lang=js&"
export * from "./UploadV2Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports